import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import * as moment from "moment";
import * as SecureLS from "secure-ls";
import { Router } from "@angular/router";
import { roleIdSix } from "../shared/constants/role.id.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "./global.service";
import { IsPointV2 } from "../app.config";
@Injectable({
  providedIn: "root",
})
export class CommonService {
  private ls = new SecureLS({ encodingType: "aes" });
  fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  fileExtension = ".xlsx";
  RoleChange: any;
  constructor(
    public router: Router,
    private modalService: NgbModal,
    public globalService: GlobalService
  ) {}

  async changeRoleService(selectedRole) {
    this.modalService.dismissAll();
    let multiRoleInputData = {
      user_id: this.ls.get("user_id"),
      role_id: selectedRole.userRole.role_id,
    };
    let multiRoleLogin = await this.globalService.create(
      "user/multirole-user-login",
      multiRoleInputData,
      IsPointV2
    );
    let compData = multiRoleLogin["content"];
    let ven_profile =
      compData.user_info.college_profile !== null
        ? compData.user_info.college_profile.logo
        : "";
    let ven_sub_admin_profile =
      compData.user_info.vendor_detail != null
        ? compData.user_info.vendor_detail.logo
        : "";
    this.ls.set("token", compData.token);
    this.ls.set("refresh_token", compData.refresh_token);
    this.ls.set("hod", compData.user_info["hod"] ? "1" : "0");
    this.ls.set("role_id", selectedRole.userRole.role_id);
    this.ls.set("role", selectedRole.userRole.role_id);
    this.ls.set("user_id", compData.user_info.id);
    this.ls.set("createdBy", compData.user_info.id);
    this.ls.set("vendor_id", compData.user_info.vendor_id);
    this.ls.set("email_address", compData.user_info.email_address);
    this.ls.set("batch_id", compData.user_info.batch_id);
    this.ls.set("section", compData.user_info.section);
    this.ls.set("student_dashboard_section_filter", compData.user_info.vendor_detail.student_dashboard_section_filter);
    this.ls.set("first_name", compData.user_info.first_name);
    this.ls.set("last_name", compData.user_info.last_name);
    this.ls.set("department_id", compData.user_info.department_id);
    this.ls.set("course_id", compData.user_info.course_id);
    this.ls.set("vendor_logo", ven_profile);
    this.ls.set("vendor_sub_logo", ven_sub_admin_profile);
    this.ls.set("password", compData.user_info.password);
    this.ls.set("write_access", compData.user_info.write_access);
    if (compData.user_info.vendor_detail != undefined) {
      this.ls.set(
        "report_permission",
        compData.user_info.vendor_detail.report_permission
      );
      this.ls.set(
        "live_class_permission",
        compData.user_info.vendor_detail.live_class_permission
      );
      this.ls.set(
        "is_student_search_all_video",
        compData.user_info.vendor_detail.is_student_search_all_video
      );
    }
    if (compData.user_info.is_password_updated == 0) {
      this.router.navigate(["/update-password"]);
    } else {
      if (parseInt(this.ls.get("role")) != roleIdSix) {
        this.router.navigate(["/dashboard"]);
      } else {
        this.router.navigate(["/video-details"]);
      }
    }
  }

  setLSDataFromResponse(compData) {
    let ven_profile =
      compData.user_info.college_profile !== null
        ? compData.user_info.college_profile.logo
        : "";
    let ven_sub_admin_profile =
      compData.user_info.vendor_detail != null
        ? compData.user_info.vendor_detail.logo
        : "";
    this.ls.set("token", compData.token);
    this.ls.set("hod", compData.user_info["hod"] ? "1" : "0");
    // if(compData.user_info.userByRole.length == 1) {
    //   if (!this.ls.get("role")) {
    //     this.ls.set("role", compData.user_info.userByRole[0].id);
    //     this.ls.set("role_id", compData.user_info.userByRole[0].id);
    //   }
    // } else {
    //   if (!this.ls.get("role")) {
    //     this.ls.set("role", compData.user_info.role_id);
    //     this.ls.set("role_id", compData.user_info.role_id);
    //   }
    // }
    
    this.ls.set("user_id", compData.user_info.id);
    this.ls.set("vendor_id", compData.user_info.vendor_id);
    this.ls.set("createdBy", compData.user_info.id);
    this.ls.set("email_address", compData.user_info.email_addres);
    this.ls.set("batch_id", compData.user_info.batch_id);
    this.ls.set("section", compData.user_info.section);
    this.ls.set("student_dashboard_section_filter", compData.user_info.vendor_detail.student_dashboard_section_filter);
    this.ls.set("first_name", compData.user_info.first_name);
    this.ls.set("last_name", compData.user_info.last_name);
    this.ls.set("department_id", compData.user_info.department_id);
    this.ls.set("course_id", compData.user_info.course_id);
    this.ls.set("vendor_logo", ven_profile);
    this.ls.set("vendor_sub_logo", ven_sub_admin_profile);
    this.ls.set("password", compData.user_info.is_password_updated);
    this.ls.set("write_access", compData.user_info.write_access);
    if (compData.user_info.vendor_detail != undefined) {
      this.ls.set(
        "report_permission",
        compData.user_info.vendor_detail.report_permission
      );
      this.ls.set(
        "live_class_permission",
        compData.user_info.vendor_detail.live_class_permission
      );
      this.ls.set(
        "is_student_search_all_video",
        compData.user_info.vendor_detail.is_student_search_all_video
      );
    }
    if (compData.user_info.is_password_updated == 0) {
      this.router.navigate(["/update-password"]);
    } else {
      if (parseInt(this.ls.get("role")) != roleIdSix) {
        this.router.navigate(["/dashboard"]);
      } else {
        this.router.navigate(["/video-details"]);
      }
    }
  }

  exportExcel(dataToExport: any[], fileName: string) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    this.autofitColumns(dataToExport, ws);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer: any = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveExcelFile(excelBuffer, fileName);
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + this.fileExtension
    );
  }

  autofitColumns(json: any[], worksheet: XLSX.WorkSheet, header?: string[]) {
    const jsonKeys = header ? header : Object.keys(json[0]);
    let objectMaxLength = [];
    for (let i = 0; i < json.length; i++) {
      let value = json[i];
      for (let j = 0; j < jsonKeys.length; j++) {
        if (typeof value[jsonKeys[j]] == "number") {
          objectMaxLength[j] = 10;
        } else {
          const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

          objectMaxLength[j] = objectMaxLength[j] >= l ? objectMaxLength[j] : l;
        }
      }

      let key = jsonKeys;
      for (let j = 0; j < key.length; j++) {
        objectMaxLength[j] =
          objectMaxLength[j] >= key[j].length
            ? objectMaxLength[j]
            : key[j].length;
      }
    }

    const wscols = objectMaxLength.map((w) => {
      return { width: w };
    });

    return (worksheet["!cols"] = wscols);
  }

  getProfessorName(professor) {
    return `${professor?.first_name} ${professor?.last_name} (${professor?.email_address})`;
  }

  getUtcTimeToLocale(dateValue, timeValue, isDateRequested) {
    var UTCDate = moment
      .utc(dateValue + " " + timeValue)
      .toDate()
      .toLocaleTimeString("en-US");
    return UTCDate;
  }
}
